import { siteActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {};

const siteReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_ALL_SUCCESS:
    case actionType.GET_SUCCESS: {
      const { siteOptions } = action.payload;
      return {
        ...state,
        options: siteOptions
      };
    }

    case actionType.GET_VERSION_SUCCESS: {
      const { version } = action.payload;

      return {
        ...state,
        version
      };
    }

    case actionType.UPDATE_SUCCESS: {
      const { successMsg } = action.payload;
      return {
        ...state,
        success: successMsg
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        error
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default siteReducer;
